import React, { useEffect, useRef, useState } from "react"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import $ from "jquery"
window.$ = window.jQuery = $
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css"
// import "datatables.net-dt";
import "datatables.net-bs4"
import axios from "axios"
import {
  deleteLeaderboardUser,
  deleteUser,
  EditLeaderboardUser,
  EditUser,
} from "services/ApiService"
import { toast, ToastContainer } from "react-toastify"
import Swal from "sweetalert2"

const LeaderBoardUserDataTable = ({ apiURL, idName, countries }) => {
  const tableRef = useRef(null)
  const token = localStorage.getItem("authorizedToken")
  const [tableData, setTableData] = useState([])
  const [isVUserShow, setIsVUserShow] = useState(false)
  const [saveLoader, setSaveLoader] = useState(false)
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [events, setEvents] = useState(null)
  const [hits, setHits] = useState(null)
  const [score, setScore] = useState(null)
  const [userId, setUserId] = useState("")
  const [currentCountry, setCurrentCountry] = useState("")

  const fetchData = (dataTablesData, callback) => {
    $("#customLoader").show()
    const reqObj = {
      ...dataTablesData,
    }
    axios
      .post(apiURL, reqObj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        const res = response.data
        $("#customLoader").hide()
        callback({
          draw: dataTablesData.draw,
          recordsTotal: res.recordsTotal,
          recordsFiltered: res.recordsFiltered,
          data: res.data,
        })
        setTableData(res.data)
      })
      .catch(err => {
        if (err.response && err.response.status === 401) {
          localStorage.clear()
          window.location.reload()
        } else {
          console.error("Error fetching data:", err)
        }
      })
  }

  const editVUser = data => {
    setIsVUserShow(true)
    setFirstName(data.firstname)
    setLastName(data.lastname)
    setEvents(data.noOfEvents)
    setHits(data.noOfHits)
    setScore(data.cumulativeScore)
    setUserId(data.id)
    setCurrentCountry(data.countryId)
    console.log("Edit User Data:", data)
  }

  const handleSaveEditEvent = () => {


if (
      !firstName.trim() ||
      !lastName.trim() ||
      !currentCountry ||
      events === null ||
      events === undefined ||
      events === "" ||
      hits === null ||
      hits === undefined ||
      hits === "" ||
      score === null ||
      score === undefined ||
      score === ""
    ) {
      toast.error("All fields are required")
      return
    }


    setSaveLoader(true)

    const reqObj = {
      firstname: firstName,
      lastname: lastName,
      noOfEvents: events,
      noOfHits: hits,
      cumulativeScore: score,
      countryId: currentCountry,
      userId: userId,
    }

    console.log("Edit User Request Object:", reqObj)

    EditLeaderboardUser(reqObj).then(res => {
      setSaveLoader(false)
      setIsVUserShow(false)
      $(tableRef.current).DataTable().ajax.reload()
      console.log("Edit User Response:", res)
      toast.success(res.msg)
      // Handle success responsea
    })
  }

  const deleteVUser = data => {
    console.log("Delete User Data:", data)
    const reqObj = {
      userId: data.id,
    }

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(result => {
      if (result.isConfirmed) {
        deleteLeaderboardUser(reqObj)
          .then(res => {
            console.log("Delete User Response:", res)
            // toast.success(res.msg)
            Swal.fire("Deleted!", res.msg, "success")

            // Handle success response
            // Optionally, you can refresh the table data here
            $(tableRef.current).DataTable().ajax.reload()
          })
          .catch(() =>
            Swal.fire("Error!", "Failed to delete material.", "error")
          )
      }
    })
  }

  const handleClose = () => {
    setIsVUserShow(false)
  }

  useEffect(() => {
    if (tableRef.current) {
      const table = $(tableRef.current).DataTable({
        processing: true,
        serverSide: true,
        ajax: fetchData,
        columns: [
          // { data: "id", title: "ID", orderable: false },
          { data: "firstname", title: "First Name" },
          { data: "lastname", title: "Last Name" },
          // { data: "email", title: "Email" },
          // { data: "countryId", title: "Country Id" },
          { data: "countryName", title: "Country Name" },
          { data: "noOfEvents", title: "Tests" },
          { data: "noOfHits", title: "Hits" },
          { data: "cumulativeScore", title: "Scores" },
          {
            data: "null",
            title: "Action",
            orderable: false,

            render: function (data, type, row) {
              return `
              <button class="btn p-0 edit-btn me-3"  data-id="${row.id}">
                <i class="bx bx-pencil fs-4"></i>
              </button>
              <button class="btn p-0 delete-btn "  data-id="${row.id}">
                <i class="bx bx-trash fs-4"></i>
              </button>
            `
            },
          },
          // {
          //   data: "createdAt",
          //   title: "Signup Date",
          //   orderable: false,
          //   render: function (data) {
          //     const date = new Date(data)
          //     const day = String(date.getDate()).padStart(2, "0")
          //     const month = String(date.getMonth() + 1).padStart(2, "0") // Months are 0-based
          //     const year = date.getFullYear()
          //     return `${day}/${month}/${year}`
          //   },
          // },
        ],
        destroy: true,
        createdRow: row => {
          // Apply inline style to center text in each cell
          $("td", row).css("text-align", "center")
        },
        headerCallback: thead => {
          // Apply inline style to center text and set background color in header cells
          $("th", thead).css({
            "text-align": "center",
            "background-color": "#f2f2f2", // Change this to your desired color
          })
        },
      })
      $(tableRef.current).on("click", ".edit-btn", function () {
        const data = table.row($(this).parents("tr")).data()
        editVUser(data)
      })

      $(tableRef.current).on("click", ".delete-btn", function () {
        const data = table.row($(this).parents("tr")).data()
        deleteVUser(data)
      })
    }
  }, [idName])

  return (
    <div>
      <ToastContainer />
      {/* <h2>Event List</h2> */}
      <div>
        <div className="table-responsive">
          <table
            id={`dataTable${idName}`}
            ref={tableRef}
            className="table table-hover table-bordered my-3"
            style={{ width: "100%", fontSize: 14, color: "#858D9D" }}
          ></table>
        </div>
      </div>
      {/* <table ref={tableRef} className="display" style={{ width: "100%" }}></table> */}
      <Modal isOpen={isVUserShow} toggle={handleClose}>
        <ModalHeader toggle={handleClose}>Edit Virtual User</ModalHeader>
        <ModalBody>
          <div className="">
            <form action="">
              <div className="">
                <label htmlFor="nov">First Name</label>
                <input
                  type="text"
                  value={firstName}
                  className="form-control"
                  id="nov"
                  onChange={e => setFirstName(e.target.value)}
                />
              </div>

              <div className="">
                <label htmlFor="nov">Last Name</label>
                <input
                  type="text"
                  value={lastName}
                  className="form-control"
                  id="nov"
                  onChange={e => setLastName(e.target.value)}
                />
              </div>

              <div className="">
                <label htmlFor="event">Events</label>
                <input
                  type="text"
                  value={events}
                  className="form-control"
                  id="event"
                  onChange={e => setEvents(e.target.value)}
                />
              </div>

              <div className="">
                <label htmlFor="hits">Hits</label>
                <input
                  type="text"
                  value={hits}
                  className="form-control"
                  id="hits"
                  onChange={e => setHits(e.target.value)}
                />
              </div>

              <div className="">
                <label htmlFor="score">Score</label>
                <input
                  type="text"
                  value={score}
                  className="form-control"
                  id="score"
                  onChange={e => setScore(e.target.value)}
                />
              </div>

              <div className="">
                <label htmlFor="nov">Country</label>
                <select
                  name=""
                  id=""
                  value={currentCountry}
                  className="form-control"
                  onChange={e => setCurrentCountry(e.target.value)}
                >
                  {countries.map((country, index) => {
                    return (
                      <option key={index} value={country.id}>
                        {country.name}
                      </option>
                    )
                  })}
                </select>
              </div>
            </form>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            Close
          </Button>
          {/* <Button color="primary" onClick={handleClose}>
    Save Changes
  </Button> */}
          <Button
            color="primary"
            onClick={handleSaveEditEvent}
            // disabled={nov === originalNov}
            className=""
          >
            {saveLoader ? (
              <div
                className="spinner-border spinner-border-sm text-light mx-5"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              " Save Changes"
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default LeaderBoardUserDataTable
